import Receipt from './receipt';

export default Receipt;
